/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B100140 単価マスタメンテ
 */
import { Column } from "@material-table/core";
import {
  B000200ShohinNm,
  B000200ShohinNmFrom,
  B000200ShohinNmTo,
  B000202ShohinchubunruiNmFrom,
  B000202ShohinchubunruiNmTo,
  B000202ShohindaibunruiNmFrom,
  B000202ShohindaibunruiNmTo,
  B000202ShohinshobunruiNmFrom,
  B000202ShohinshobunruiNmTo,
  B100140Create,
  B100140CreateRequest,
  B100140Delete,
  B100140DeleteRequest,
  B100140Find,
  B100140FindRequest,
  B100140Update,
  B100140UpdateRequest,
  catchRestError,
} from "clients/rest";
import {
  msgState,
  SCancelButton,
  SCodeSelect,
  SDateField,
  SEntryTab,
  SFileButton,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  STable,
  SText,
  STextField,
} from "components";
import { getClientMessage } from "messages";
import { B100140TankaKbn, getSCode, SCode } from "messages/codes";
import { labels } from "messages/labels";
import { B000200, B000202, GamenInputId } from "pages";
import { createRef, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { dateWithSlashAt, digit, mapIds } from "services";
import { focusState, navigateTypeState, useFocus } from "states";

// 呼び出し時のプロパティ
type Props = Partial<{
  // 呼び出し元へデータを送る場合に設定する。
  handleSubmit: (data: any) => void;
}>;

// コンポーネントで設定されるフィールドの型を定義する
// ヘッダ部
type Fields = Partial<{
  tankaKbn: SCode;
  kikanymd: string;
  shohinCdFrom: string;
  shohinNmFrom: string;
  shohinCdTo: string;
  shohinNmTo: string;
  shodaibunFrom: string;
  shohindaibunruiNmFrom: string;
  shodaibunTo: string;
  shohindaibunruiNmTo: string;
  shochubunFrom: string;
  shohinchubunruiNmFrom: string;
  shochubunTo: string;
  shohinchubunruiNmTo: string;
  shoshobunFrom: string;
  shohinshobunruiNmFrom: string;
  shoshobunTo: string;
  shohinshobunruiNmTo: string;
}>;

// タブ部
type TabFields = Partial<{
  tab: boolean;
  tankaKbn: string;
  shohinCd: string;
  shohinNm: string;
  defaultKikanFromymd: string;
  kikanFromymd: string | null;
  tanka: string;
  genkatanka: string;
  tankaVersion: number;
  genkaVersion: number;
}>;

//テーブルデータの定義
type Data = Partial<{
  gyoNo: number;
  shohinCd: string;
  shohinNm: string;
  kikanFromymdF: string;
  kikanFromymd: string;
  tanka: string;
  genkatanka: string;
  tankaVersion: number;
  genkaVersion: number;
  tankaKbn: string;
}>;

// フィールドの初期値を設定する。
// ヘッダ部
const defaultFields: Fields = {
  tankaKbn: getSCode(B100140TankaKbn, "0"),
  kikanymd: "",
  shohinCdFrom: "",
  shohinNmFrom: "",
  shohinCdTo: "",
  shohinNmTo: "",
  shodaibunFrom: "",
  shohindaibunruiNmFrom: "",
  shodaibunTo: "",
  shohindaibunruiNmTo: "",
  shochubunFrom: "",
  shohinchubunruiNmFrom: "",
  shochubunTo: "",
  shohinchubunruiNmTo: "",
  shoshobunFrom: "",
  shohinshobunruiNmFrom: "",
  shoshobunTo: "",
  shohinshobunruiNmTo: "",
};

// タブ部
const defaultTabFields: TabFields = {
  tab: true,
  tankaKbn: "",
  shohinCd: "",
  shohinNm: "",
  defaultKikanFromymd: "",
  kikanFromymd: null,
  tanka: "",
  genkatanka: "",
  tankaVersion: undefined,
  genkaVersion: undefined,
};

const columns: Column<Data>[] = [
  { field: "gyoNo", title: "行　", width: "3rem", align: "right" },
  { field: "shohinCd", title: "商品コード", width: "8rem" },
  { field: "shohinNm", title: "商品名", width: "20rem" },
  { field: "kikanFromymd", hidden: true },
  { field: "kikanFromymdF", title: "期間開始", width: "10rem" },
  {
    field: "tanka",
    title: "上代　",
    width: "5rem",
    align: "right",
    render: (data) => digit(data.tanka),
  },
  {
    field: "genkatanka",
    title: "原価　",
    width: "5rem",
    align: "right",
    render: (data) => digit(data.genkatanka),
  },
  { field: "tankaVersion", hidden: true },
  { field: "genkaVersion", hidden: true },
  { field: "tankaKbn", hidden: true },
];

const columnsShire: Column<Data>[] = [
  { field: "gyoNo", title: "行　", width: "3rem", align: "right" },
  { field: "shohinCd", title: "商品コード", width: "8rem" },
  { field: "shohinNm", title: "商品名", width: "20rem" },
  { field: "kikanFromymd", hidden: true },
  { field: "kikanFromymdF", title: "期間開始", width: "10rem" },
  {
    field: "tanka",
    title: "単価　",
    width: "5rem",
    align: "right",
    render: (data) => digit(data.tanka),
  },
  {
    field: "genkatanka",
    title: "原価　",
    width: "5rem",
    align: "right",
    render: (data) => digit(data.genkatanka),
  },
  { field: "tankaVersion", hidden: true },
  { field: "genkaVersion", hidden: true },
  { field: "tankaKbn", hidden: true },
];

// 固定値
const focusId = "B100140";
// 単価区分2:仕入
const tankaKbnShire = "2";

// B100140 単価マスタメンテ
export const B100140 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // フォーム関数
  const tabMethods = useForm<TabFields>({
    mode: "onBlur",
    defaultValues: defaultTabFields,
  });

  // テーブル管理
  const tableRef = createRef();
  const [rows, setRows] = useState<Data[]>([]);
  // テーブル行で選択されたデータ
  const [rowData, setRowData] = useState<Partial<Data>>();
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // 遷移元データ取得用
  const navigate = useNavigate();
  // エラー表示
  const setMsg = useSetRecoilState(msgState);
  // 活性制御
  // 単価区分が仕入かどうか
  const isTankaKbnShire = methods.watch("tankaKbn")?.value === tankaKbnShire;
  // 画面遷移の処理
  const [menuNavigate, setMenuNavigate] = useRecoilState(navigateTypeState);

  // 初期表示イベント
  useEffect(() => {
    focus(1);
  }, []);
  // 検索ボタンクリックイベント
  const handleClickSearchButton = () => {
    // 検索フォームのデータを取得する。
    const fields = methods.getValues();

    // タブ部に単価区分をセット
    tabMethods.setValue("tankaKbn", fields.tankaKbn?.value);

    // 検索パラメータを作成する。
    const param: B100140FindRequest = {
      tankaKbn: fields.tankaKbn?.value!,
      kikanymd: fields.kikanymd,
      shohinCdFrom: fields.shohinCdFrom,
      shohinCdTo: fields.shohinCdTo,
      shodaibunFrom: fields.shodaibunFrom,
      shodaibunTo: fields.shodaibunTo,
      shochubunFrom: fields.shochubunFrom,
      shochubunTo: fields.shochubunTo,
      shoshobunFrom: fields.shoshobunFrom,
      shoshobunTo: fields.shoshobunTo,
    };

    // API呼出し
    B100140Find(param)
      .then((value) => {
        // グリッドへのマッピング
        const gridDataList = value.data.map<Data>((value, index) => {
          // 行番号
          const gyoNo: number = index + 1;
          // 行のデータセット
          const data: Data = {
            gyoNo: Number(gyoNo),
            shohinCd: value.shohinCd,
            shohinNm: value.shohinNm,
            kikanFromymd: value.kikanFromymd,
            kikanFromymdF: dateWithSlashAt(value.kikanFromymd),
            tanka: value.tanka,
            genkatanka: value.genkatanka,
            tankaVersion: value.tankaVersion,
            genkaVersion: value.genkaVersion,
            tankaKbn: value.tankaKbn,
          };
          return data;
        });
        // テーブルに反映
        setRows(gridDataList);
      })
      // エラー時
      .catch((reason) => {
        setRows([]);
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 登録
  const handleCreate = () => {
    const fields = methods.getValues();
    // タブ部のデータ取得
    const tabFields = tabMethods.getValues();

    // 新規登録するデータの作成
    const newData: B100140CreateRequest = {
      tankaKbn: fields.tankaKbn?.value!,
      shohinCd: tabFields.shohinCd!,
      kikanFromymd: tabFields.kikanFromymd!,
      tanka: tabFields.tanka!,
      genkatanka: tabFields.genkatanka,
    };

    // API呼出し
    B100140Create(newData)
      .then(() => {
        // 新規登録した行の追加
        addRow(newData);
        // タブ部の各項目を初期化する。
        tabMethods.reset();
        tabMethods.setValue("tankaKbn", newData.tankaKbn);
        // 登録完了メッセージ表示
        setMsg(getClientMessage("B100140_001"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 更新
  const handleUpdate = () => {
    const tabFields = tabMethods.getValues();

    // 更新データ取得
    const updateData: B100140UpdateRequest = {
      tankaKbn: tabFields.tankaKbn!,
      shohinCd: tabFields.shohinCd!,
      defaultKikanFromymd: tabFields.defaultKikanFromymd!,
      kikanFromymd: tabFields.kikanFromymd!,
      tanka: tabFields.tanka!,
      genkatanka: tabFields.genkatanka,
      tankaVersion: tabFields.tankaVersion!,
      genkaVersion: tabFields.genkaVersion,
    };

    // API呼出し
    B100140Update(updateData)
      .then(() => {
        // 更新した行の表示更新
        updateRow(updateData);
        // タブ部の各項目を初期化する。
        tabMethods.reset();
        tabMethods.setValue("tankaKbn", updateData.tankaKbn);
        // 更新完了メッセージ表示
        setMsg(getClientMessage("B100140_002"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 削除
  const handleDelete = () => {
    const tabFields = tabMethods.getValues();

    // 削除データ取得
    const delData: B100140DeleteRequest = {
      tankaKbn: tabFields.tankaKbn!,
      shohinCd: tabFields.shohinCd!,
      kikanFromymd: tabFields.kikanFromymd!,
    };

    // API呼出し
    B100140Delete(delData)
      .then(() => {
        // 他期間の更新処理
        handleUpdateOtherKikan(
          rowData?.tankaKbn!,
          rowData?.shohinCd!,
          rowData?.kikanFromymd!
        );

        // 選択行の削除処理
        // 選択行の行番号取得
        const gyoNo = rowData?.gyoNo;
        // 取得した行番号の行を除いた全てのデータを取得
        const newRows = rows.filter(function (source: Data) {
          return source.gyoNo !== gyoNo;
        });
        // 明細テーブルの行番号振り直し
        mapIds(newRows, "gyoNo");
        // 削除後のデータセット
        setRows(newRows);
        // タブ部の各項目を初期化する。
        tabMethods.reset();
        tabMethods.setValue("tankaKbn", delData.tankaKbn);
        // 削除完了メッセージ表示
        setMsg(getClientMessage("B100140_003"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // テーブル行ダブルクリックイベント
  const handleDoubleClickTableRow = (rowData: Data) => {
    tabMethods.reset();
    // タブを編集にする
    tabMethods.setValue("tab", false);
    // ダブルクリックした行を選択状態にする
    setRowData(rowData);
    // タブ部にデータを表示する。
    tabMethods.setValue("shohinCd", rowData.shohinCd);
    tabMethods.setValue("shohinNm", rowData.shohinNm);
    tabMethods.setValue("defaultKikanFromymd", rowData.kikanFromymd);
    tabMethods.setValue("kikanFromymd", rowData.kikanFromymd);
    tabMethods.setValue("tanka", rowData.tanka);
    tabMethods.setValue("genkatanka", rowData.genkatanka);
    tabMethods.setValue("tankaVersion", rowData.tankaVersion);
    tabMethods.setValue("genkaVersion", rowData.genkaVersion);
    tabMethods.setValue("tankaKbn", rowData.tankaKbn);
  };

  // タブ切り替え
  const handleChangeTab = () => {
    // 行選択解除
    setRowData(undefined);
    // タブ部の値を初期化
    tabMethods.reset();
    // タブ部に単価区分をセット
    tabMethods.setValue("tankaKbn", methods.watch("tankaKbn")?.value);
  };

  // 新規登録行の追加
  const addRow = (newData: B100140CreateRequest) => {
    // フォームのデータを取得する。
    const fields = methods.getValues();
    const gyoNo: number = rows.length + 1;
    const newRowData: Data = {
      gyoNo: gyoNo,
      shohinCd: newData.shohinCd,
      shohinNm: tabMethods.watch("shohinNm"),
      kikanFromymd: newData.kikanFromymd,
      kikanFromymdF: dateWithSlashAt(newData.kikanFromymd),
      tanka: newData.tanka,
      genkatanka: newData.genkatanka,
      tankaVersion: 1,
      genkaVersion: 1,
      tankaKbn: fields.tankaKbn?.value,
    };

    // 他期間の更新処理
    handleUpdateOtherKikan(
      newData.tankaKbn,
      newData.shohinCd,
      newData.kikanFromymd
    );

    setRows([...rows, newRowData]);
  };

  // 更新行の表示更新
  const updateRow = (updateData: B100140UpdateRequest) => {
    const gyoNo: number = rowData!.gyoNo!;
    const updRowData: Data = {
      gyoNo: gyoNo,
      shohinCd: updateData.shohinCd,
      shohinNm: tabMethods.watch("shohinNm"),
      kikanFromymd: updateData.kikanFromymd,
      kikanFromymdF: dateWithSlashAt(updateData.kikanFromymd),
      tanka: updateData.tanka,
      genkatanka: updateData.genkatanka,
      tankaVersion: updateData.tankaVersion + 1,
      genkaVersion: updateData.genkaVersion! + 1,
      tankaKbn: updateData.tankaKbn,
    };

    rows[gyoNo - 1] = updRowData;

    // 他期間の更新処理
    handleUpdateOtherKikan(
      updateData.tankaKbn,
      updateData.shohinCd,
      updateData.kikanFromymd
    );
    setRows([...rows]);
  };

  // 他期間の更新処理
  const handleUpdateOtherKikan = (
    tankaKbn: string,
    shohinCd: string,
    kikanFromymd: string
  ) => {
    // 明細が設定されていない場合
    if (rows.length === 0) return;

    // 今回分の期間開始日より小さい日付が存在するかチェック
    const isExsists: boolean = rows.some((row) => {
      return row.kikanFromymd! < kikanFromymd;
    });
    if (!isExsists) {
      return;
    }

    // 前回分の期間開始を取得
    const kikanFromymdBefore: string | undefined = rows
      // リスト.期間開始 < 今回分.期間開始で絞り込む
      .filter((row) => row.kikanFromymd! < kikanFromymd)
      .reduce((a, b) =>
        a.kikanFromymd! > b.kikanFromymd! ? a : b
      ).kikanFromymd;

    // 取得できなかった場合
    if (typeof kikanFromymdBefore === "undefined") return;
    if (kikanFromymdBefore === "") return;

    for (const row of rows) {
      // 単価区分が一致しない場合、何もしない
      if (tankaKbn !== row.tankaKbn) continue;
      // 商品コードが一致しない場合、何もしない
      if (shohinCd !== row.shohinCd) continue;
      // 期間開始が一致しない場合、何もしない
      if (kikanFromymdBefore !== row.kikanFromymd) continue;

      // version更新
      row.tankaVersion = row.tankaVersion! + 1;
      row.genkaVersion = row.genkaVersion! + 1;
    }
  };

  // excelボタンクリック時
  const handleMoveOutput = () => {
    // 単価マスタ出力画面へ遷移する。
    setMenuNavigate("next");
    navigate("/b100143");
  };

  // excel取込ボタンクリック時
  const handleMoveImport = () => {
    const gamenInputId: GamenInputId = {
      gamenId: "100140",
    };

    // マスタ取込画面へ遷移する。
    setMenuNavigate("next");
    navigate("/b100900", { state: gamenInputId });
  };

  // レイアウト設定
  return (
    <>
      <FormProvider {...methods}>
        <SFrame
          title="単価マスタメンテ"
          gridTemplateColumns="8rem 5rem 3rem 12rem 3rem 1rem 5rem 3rem 12rem 3rem 6rem "
        >
          <SText gridColumn="span 8"></SText>
          <SFileButton
            label={labels.buttons.excel}
            align="right"
            gridColumn="span 2"
            {...register(11)}
            onClick={handleMoveOutput}
          />
          <SNormalButton
            label={labels.buttons.excelImport}
            align="right"
            {...register(12)}
            onClick={handleMoveImport}
          />

          <SLabel required gridColumn="1">
            単価分類
          </SLabel>
          <SCodeSelect
            name="tankaKbn"
            label="単価分類"
            required
            options={B100140TankaKbn}
            gridColumn="span 2"
            {...register(1)}
          />

          <SLabel gridColumn="1">有効日付</SLabel>
          <SDateField
            name="kikanymd"
            label="有効日付"
            gridColumn="span 2"
            {...register(2)}
          />

          <SLabel gridColumn="1">商品コード</SLabel>
          <SNumberField
            name="shohinCdFrom"
            code
            size={10}
            gridColumn="span 2"
            dialog={<B000200 />}
            handleSubmit={(data: any) => {
              methods.setValue("shohinCdFrom", data.shohinCd ?? "");
              methods.setValue("shohinNmFrom", data.shohinNmr ?? "");
            }}
            onBlur={() => B000200ShohinNmFrom(methods, navigate, setMsg)}
            {...register(3)}
          />
          <STextField name="shohinNmFrom" disabled gridColumn="span 2" />
          <SText>～</SText>
          <SNumberField
            name="shohinCdTo"
            code
            size={10}
            gridColumn="span 2"
            dialog={<B000200 />}
            handleSubmit={(data: any) => {
              methods.setValue("shohinCdTo", data.shohinCd ?? "");
              methods.setValue("shohinNmTo", data.shohinNmr ?? "");
            }}
            onBlur={() => B000200ShohinNmTo(methods, navigate, setMsg)}
            {...register(4)}
          />
          <STextField name="shohinNmTo" disabled gridColumn="span 2" />

          <SLabel gridColumn="1">商品大分類コード</SLabel>
          <SNumberField
            name="shodaibunFrom"
            code
            size={3}
            dialog={<B000202 />}
            handleSubmit={(data: any) => {
              methods.setValue("shodaibunFrom", data.shodaibun ?? "");
              (async () => {
                await B000202ShohindaibunruiNmFrom(methods, navigate, setMsg);
              })();
            }}
            onBlur={() =>
              B000202ShohindaibunruiNmFrom(methods, navigate, setMsg)
            }
            {...register(5)}
          />
          <STextField
            name="shohindaibunruiNmFrom"
            disabled
            gridColumn="span 2"
          />
          <SText></SText>
          <SText>～</SText>
          <SNumberField
            name="shodaibunTo"
            code
            size={3}
            dialog={<B000202 />}
            handleSubmit={(data: any) => {
              methods.setValue("shodaibunTo", data.shodaibun ?? "");
              (async () => {
                await B000202ShohindaibunruiNmTo(methods, navigate, setMsg);
              })();
            }}
            onBlur={() => B000202ShohindaibunruiNmTo(methods, navigate, setMsg)}
            {...register(6)}
          />
          <STextField name="shohindaibunruiNmTo" disabled gridColumn="span 2" />

          <SLabel gridColumn="1">商品中分類コード</SLabel>
          <SNumberField
            name="shochubunFrom"
            code
            size={3}
            dialog={<B000202 />}
            handleSubmit={(data: any) => {
              methods.setValue("shodaibunFrom", data.shodaibun ?? "");
              methods.setValue("shochubunFrom", data.shochubun ?? "");
              (async () => {
                await B000202ShohindaibunruiNmFrom(methods, navigate, setMsg);
                await B000202ShohinchubunruiNmFrom(methods, navigate, setMsg);
              })();
            }}
            onBlur={() =>
              B000202ShohinchubunruiNmFrom(methods, navigate, setMsg)
            }
            {...register(7)}
          />
          <STextField
            name="shohinchubunruiNmFrom"
            disabled
            gridColumn="span 2"
          />
          <SText></SText>
          <SText>～</SText>
          <SNumberField
            name="shochubunTo"
            code
            size={3}
            dialog={<B000202 />}
            handleSubmit={(data: any) => {
              methods.setValue("shodaibunTo", data.shodaibun ?? "");
              methods.setValue("shochubunTo", data.shochubun ?? "");
              (async () => {
                await B000202ShohindaibunruiNmTo(methods, navigate, setMsg);
                await B000202ShohinchubunruiNmTo(methods, navigate, setMsg);
              })();
            }}
            onBlur={() => B000202ShohinchubunruiNmTo(methods, navigate, setMsg)}
            {...register(8)}
          />
          <STextField name="shohinchubunruiNmTo" disabled gridColumn="span 2" />

          <SLabel gridColumn="1">商品小分類コード</SLabel>
          <SNumberField
            name="shoshobunFrom"
            code
            size={3}
            dialog={<B000202 />}
            handleSubmit={(data: any) => {
              methods.setValue("shodaibunFrom", data.shodaibun ?? "");
              methods.setValue("shochubunFrom", data.shochubun ?? "");
              methods.setValue("shoshobunFrom", data.shoshobun ?? "");
              (async () => {
                await B000202ShohindaibunruiNmFrom(methods, navigate, setMsg);
                await B000202ShohinchubunruiNmFrom(methods, navigate, setMsg);
                await B000202ShohinshobunruiNmFrom(methods, navigate, setMsg);
              })();
            }}
            onBlur={() =>
              B000202ShohinshobunruiNmFrom(methods, navigate, setMsg)
            }
            {...register(9)}
          />
          <STextField
            name="shohinshobunruiNmFrom"
            disabled
            gridColumn="span 2"
          />
          <SText></SText>
          <SText>～</SText>
          <SNumberField
            name="shoshobunTo"
            code
            size={3}
            dialog={<B000202 />}
            handleSubmit={(data: any) => {
              methods.setValue("shodaibunTo", data.shodaibun ?? "");
              methods.setValue("shochubunTo", data.shochubun ?? "");
              methods.setValue("shoshobunTo", data.shoshobun ?? "");
              (async () => {
                await B000202ShohindaibunruiNmTo(methods, navigate, setMsg);
                await B000202ShohinchubunruiNmTo(methods, navigate, setMsg);
                await B000202ShohinshobunruiNmTo(methods, navigate, setMsg);
              })();
            }}
            onBlur={() => B000202ShohinshobunruiNmTo(methods, navigate, setMsg)}
            {...register(10)}
          />
          <STextField name="shohinshobunruiNmTo" disabled gridColumn="span 2" />

          <SText gridColumn="span 10"></SText>
          <SNormalButton
            onClick={handleClickSearchButton}
            label={labels.buttons.search}
            align="right"
            {...register(13)}
          />
        </SFrame>
      </FormProvider>

      <SFrame>
        {!isTankaKbnShire ? (
          <>
            <STable
              keyName="gyoNo"
              data={rows}
              columns={columns}
              tableRef={tableRef}
              handleDoubleClick={handleDoubleClickTableRow}
              width={1000}
              height={430}
              pageSize={15}
            />
          </>
        ) : (
          <>
            <STable
              keyName="gyoNo"
              data={rows}
              columns={columnsShire}
              tableRef={tableRef}
              handleDoubleClick={handleDoubleClickTableRow}
              width={1000}
              height={430}
              pageSize={15}
            />
          </>
        )}
      </SFrame>

      <FormProvider {...tabMethods}>
        <SFrame>
          <SEntryTab name="tab" handleOk={handleChangeTab}></SEntryTab>
          <SFrame gridTemplateColumns="8rem 15rem 8rem 8rem 8rem">
            <SLabel required>商品コード</SLabel>
            <SLabel>商品名</SLabel>
            <SLabel required>期間開始</SLabel>

            {!isTankaKbnShire ? (
              <>
                <SLabel required={tabMethods.getValues().tab === false}>
                  上代
                </SLabel>
              </>
            ) : (
              <>
                <SLabel required={tabMethods.getValues().tab === false}>
                  単価
                </SLabel>
              </>
            )}

            <SLabel
              required={
                !isTankaKbnShire && tabMethods.getValues().tab === false
              }
            >
              原価
            </SLabel>

            <SNumberField
              name="shohinCd"
              label="商品コード"
              code
              required
              disabled={tabMethods.getValues().tab === false}
              size={10}
              dialog={<B000200 />}
              handleSubmit={(data: any) => {
                tabMethods.setValue("shohinCd", data.shohinCd ?? "");
                tabMethods.setValue("shohinNm", data.shohinNmr ?? "");
              }}
              onBlur={() => B000200ShohinNm(tabMethods, navigate, setMsg)}
              {...register(14)}
            />
            <STextField name="shohinNm" disabled />
            <SDateField
              name="kikanFromymd"
              label="期間開始"
              required
              {...register(15)}
            />
            <SNumberField
              name="tanka"
              size={9}
              align="right"
              required={tabMethods.getValues().tab === false}
              {...register(16)}
            />
            <SNumberField
              name="genkatanka"
              size={9}
              align="right"
              required={tabMethods.getValues().tab === false}
              disabled={isTankaKbnShire}
              {...register(17)}
            />

            {tabMethods.getValues().tab === true ? (
              <SNormalButton
                label={labels.buttons.create}
                gridRow="3"
                gridColumn="5"
                align="right"
                {...register(18)}
                onClick={handleCreate}
              />
            ) : (
              <>
                <SCancelButton
                  label={labels.buttons.linedeletion}
                  gridRow="3"
                  align="left"
                  {...register(19)}
                  onClick={handleDelete}
                />
                <SNormalButton
                  label={labels.buttons.update}
                  gridRow="3"
                  gridColumn="5"
                  align="right"
                  {...register(20)}
                  onClick={handleUpdate}
                />
              </>
            )}
          </SFrame>
        </SFrame>
      </FormProvider>
    </>
  );
};
